import React, { useEffect, useState } from "react";
import {
  Goto,
  HeroSm,
  ItemList,
  NavBar,
  Pagination,
  Spinner,
} from "../components";
import { Footer } from "../layouts";
import $ from "jquery";
import axios from "axios";
import config from "../config";
import { Slang } from "../helpers";
// import data from '../data_test.json';

const Listing = () => {
  const [loadPage, setLoadPage] = useState(true);
  // const [spinColor, setSpinColor] = useState("success");

  useEffect(() => {
    let tim2 = setTimeout(() => {
      setLoadPage(false);
    }, 100);

    return () => {
      clearInterval(tim2);
    };
  }, []);

  return (
    <>
      {loadPage ? (
        <>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
              width: "100%",
              position: "fixed",
              left: 0,
              top: 0,
            }}
          >
            <Spinner grow color={"success"} size={5} />
          </div>
        </>
      ) : (
        <>
          <Lister>
            <Main />
          </Lister>

          <Goto />
        </>
      )}

      {/*<Helmet>*/}
      {/*    /!* <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600&display=swap" rel="stylesheet" /> *!/*/}
      {/*    <title>ABN | Directories</title>*/}
      {/*    <link rel="stylesheet" href="./assets/css/bootstrap/icons/bootstrap-icons.css" />*/}
      {/*    <link rel="stylesheet" href="./assets/css/hs/mega-menu/mega-menu.min.css" />*/}
      {/*    <link rel="stylesheet" href="./assets/css/nouislider/nouislider.min.css" />*/}
      {/*    <link rel="stylesheet" href="./assets/css/tom-select/tom-select.bootstrap5.css" />*/}
      {/*    <link rel="stylesheet" href="./assets/css/_theme.css" />*/}

      {/*    <script defer asyn src="./assets/js/bootstrap/bootstrap.bundle.min.js"></script>*/}
      {/*    <script defer asyn src="./assets/js/hs/mega-menu/mega-menu.min.js"></script>*/}

      {/*    <script defer asyn src="./assets/js/hs/go-to/goto.min.js"></script>*/}

      {/*    <script defer asyn src="./assets/js/nouislider/nouislider.min.js"></script>*/}
      {/*    <script defer asyn src="./assets/js/fslightbox/index.js"></script>*/}
      {/*    <script defer asyn src="./assets/js/tom-select/tom-select.complete.min.js"></script>*/}

      {/*    <script defer asyn src="./assets/js/prism/prism.js"></script>*/}
      {/*    <script defer asyn src="./assets/js/hs/show-animation/show-animation.min.js"></script>*/}
      {/*    <script defer asyn src="./assets/js/hs/header/header.min.js"></script>*/}
      {/*    <script defer asyn src="./assets/js/theme.min.js"></script>*/}

      {/*</Helmet>*/}
    </>
  );
};

export default Listing;

const Lister = ({ children }) => {
  useEffect(() => {
    const script = `
        new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});

        HSBsValidation.init('.js-validate', {
            onSubmit: data => {
                data.event.preventDefault();
                alert('Submited');
                }
            });

            HSBsDropdown.init();

            new HSGoTo('.js-go-to');
            
            
            var rangeReady = false;


            new HSHeader('#header').init();
            HSCore.components.HSTomSelect.init('.js-select');
        `;

    $("body").append(`<script className="homescript">${script}</script>`);

    return () => {
      $(".homescript").remove();
    };
  }, []);

  return (
    <>
      <NavBar transparent />
      <HeroSm title={"Business Directories"} />
      {children}
      <Footer />
    </>
  );
};

const Main = () => {
  const [business, setBusiness] = useState(null);
  const [filteredData, setFilteredData] = useState(business?.data?.data || []);
  const [isFunctionCalled, setIsFunctionCalled] = useState(false);
  const lang = Slang("Business");
  const [searchTerm, setSearchTerm] = useState("");

  const getBusiness = async () => {
    const { data } = await axios.get(`${config.apiUrl}/companies`, {});
    setBusiness(data);
  };

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
    const filterData = business.data.data.filter((item) =>
      item.name.toLowerCase().includes(event.target.value.toLowerCase())
    );

    if (event.target.value === "") {
      setFilteredData(business?.data?.data || []);
      setIsFunctionCalled(false);
    } else {
      setFilteredData(filterData);
      setIsFunctionCalled(true);
    }
  };

  useEffect(() => {
    getBusiness();
  }, []);

  return (
    <>
      <main id="content" role="main">
        <div className="container content-space-t-1 content-space-t-lg-2">
          <form>
            <div className="row gx-2">
              <div className="col-lg mb-2 mb-lg-0">
                <label
                  htmlFor="searchPropertyFilterForm"
                  className="visually-hidden form-label"
                >
                  {lang("t1")}
                </label>
                <div className="input-group input-group-merge">
                  <span className="input-group-prepend input-group-text">
                    <i className="bi-search"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    id="searchPropertyFilterForm"
                    value={searchTerm}
                    onChange={handleSearch}
                    placeholder={lang("t1")}
                    aria-label="Rechercher une entreprise"
                  />
                </div>
              </div>

              <div className="col-auto mb-2 mb-lg-0 d-flex">
                {/* <a className="btn btn-white btn-sm" href="#/" data-bs-toggle="modal" data-bs-target="#realEstateMoreFiltersModal">
                                <i className="bi-sliders me-2"></i> More
                            </a> */}
                {/* <input
                  type="button"
                  value={lang("t2")}
                  onClick={handleSearch}
                  className="form-control form-control-sm btn btn-primary btn-sm"
                  id="filterButton"
                /> */}
                {/* <input type="reset" value="Reset" className="form-control form-control-sm btn btn-danger btn-sm" id="searchPropertyFilterForm" /> */}
              </div>
            </div>
          </form>
        </div>

        <div className="container content-space-t-1 content-space-b-2 content-space-b-lg-3">
          {business === null ? (
            <div className="container text-center my-4">
              <Spinner grow={false} color={"success"} size={3} />
            </div>
          ) : (
            <>
              <div className="mb-5">
                <div className="row align-items-center">
                  <div className="col-sm mb-3 mb-sm-0">
                    <span className="d-block">
                      {isFunctionCalled
                        ? filteredData.length
                        : business.data?.total}
                      {lang("t3")}
                    </span>
                    <h1 className="h2 mb-0">{lang("t4")}</h1>
                  </div>

                  {/* <div className="col-sm-auto">
                                    <select className="form-select form-select-sm">
                                        <option value="mostRecent" defaultValue={}>Most recent</option>
                                        <option value="HighestPrice">Highest price</option>
                                        <option value="LowestPrice">Lowest price</option>
                                        <option value="mostReduced">Most reduced</option>
                                        <option value="mostPopular">Most popular</option>
                                    </select>
                                </div> */}
                </div>
              </div>

              <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-3 mb-5">
                <ItemList
                  items={isFunctionCalled ? filteredData : business?.data?.data}
                />
              </div>
            </>
          )}

          <Pagination setBusiness={setBusiness} />
        </div>
      </main>
    </>
  );
};
